import { create } from "zustand";

interface BlockbrainState {
  localApiKey: string;
  localApiUrl: string;
  localBotId: string;
  originalApiKey: string;
  originalApiUrl: string;
  originalBotId: string;
  hasChanges: boolean;
  setLocalApiKey: (key: string) => void;
  setLocalApiUrl: (url: string) => void;
  setLocalBotId: (botId: string) => void;
  setOriginalApiKey: (key: string) => void;
  setOriginalApiUrl: (url: string) => void;
  setOriginalBotId: (botId: string) => void;
  resetChanges: () => void;
}

const computeHasChanges = (
  localApiKey: string,
  localApiUrl: string,
  localBotId: string,
  originalApiKey: string,
  originalApiUrl: string,
  originalBotId: string,
) =>
  localApiKey !== originalApiKey ||
  localApiUrl !== originalApiUrl ||
  localBotId !== originalBotId;

const BlockbrainStore = create<BlockbrainState>((set, get) => ({
  localApiKey: "",
  localApiUrl: "",
  localBotId: "",
  originalApiKey: "",
  originalApiUrl: "",
  originalBotId: "",
  hasChanges: false,

  setLocalApiKey: (key: string) => {
    const { originalApiKey, localApiUrl, originalApiUrl, localBotId, originalBotId } = get();
    set({
      localApiKey: key,
      hasChanges: computeHasChanges(key, localApiUrl, localBotId, originalApiKey, originalApiUrl, originalBotId),
    });
  },

  setLocalApiUrl: (url: string) => {
    const { originalApiUrl, localApiKey, originalApiKey, localBotId, originalBotId } = get();
    set({
      localApiUrl: url,
      hasChanges: computeHasChanges(localApiKey, url, localBotId, originalApiKey, originalApiUrl, originalBotId),
    });
  },

  setLocalBotId: (botId: string) => {
    const { localApiKey, originalApiKey, localApiUrl, originalApiUrl, originalBotId } = get();
    set({
      localBotId: botId,
      hasChanges: computeHasChanges(localApiKey, localApiUrl, botId, originalApiKey, originalApiUrl, originalBotId),
    });
  },

  setOriginalApiKey: (key: string) => {
    const { localApiUrl, originalApiUrl, localBotId, originalBotId } = get();
    set({
      originalApiKey: key,
      localApiKey: key,
      hasChanges: computeHasChanges(key, localApiUrl, localBotId, key, originalApiUrl, originalBotId),
    });
  },

  setOriginalApiUrl: (url: string) => {
    const { localApiKey, originalApiKey, localBotId, originalBotId } = get();
    set({
      originalApiUrl: url,
      localApiUrl: url,
      hasChanges: computeHasChanges(localApiKey, url, localBotId, originalApiKey, url, originalBotId),
    });
  },

  setOriginalBotId: (botId: string) => {
    const { localApiKey, originalApiKey, localApiUrl, originalApiUrl } = get();
    set({
      originalBotId: botId,
      localBotId: botId,
      hasChanges: computeHasChanges(localApiKey, localApiUrl, botId, originalApiKey, originalApiUrl, botId),
    });
  },

  resetChanges: () => {
    const { originalApiKey, originalApiUrl, originalBotId } = get();
    set({
      localApiKey: originalApiKey,
      localApiUrl: originalApiUrl,
      localBotId: originalBotId,
      hasChanges: false,
    });
  },
}));

export default BlockbrainStore;
